import { Tooltip } from "@mui/material";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import moment from "moment";
import React from "react";
import { useLocation, useNavigate } from "react-router";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";

const OrderDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state?.order;
  const containerStyle = {
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    fontSize: "16px",
  };

  const cardStyle = {
    padding: "15px",
    borderRadius: "8px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    marginBottom: "15px",
    fontSize: "16px",
  };

  const flexRow = {
    display: "flex",
    flexWrap: "wrap",
    gap: "15px",
  };

  const flexItem = {
    flex: "1 1 calc(50% - 15px)",
    minWidth: "300px",
    fontSize: "16px",
  };

  const redirect = data => {
    navigate("/product-details", { state: { productId: data.productId } });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={containerStyle}>
        <h2 style={{ paddingBottom: "16px" }}>Order Details: {state?.invoiceId} {state?.trackingNumber ? `|| TTH: ${state?.trackingNumber}` : ""}</h2>
        <div style={flexRow}>
          <div style={{ ...cardStyle, backgroundColor: "#d4edda" }}>
            <p>
              <strong>Order Created at</strong>
            </p>
            <p>
              {moment(state?.createdAt).format("ll")} at{" "}
              {moment(state?.createdAt).format("hh:mm A")}
            </p>
          </div>
          <div style={{ ...cardStyle, backgroundColor: "#f8d7da" }}>
            <p>
              <strong>Delivery Status</strong>
            </p>
            <p style={{ textTransform: "capitalize" }}>{state?.deliveryStatus}</p>
          </div>
          <div style={{ ...cardStyle, backgroundColor: "#fff3cd" }}>
            <p>
              <strong>Delivery Method</strong>
            </p>
            <p style={{ textTransform: "capitalize" }}>{state?.deliveryType}</p>
          </div>
          <div style={{ ...cardStyle, backgroundColor: "#d1ecf1" }}>
            <p>
              <strong>Payment Method</strong>
            </p>
            <p style={{ textTransform: "capitalize" }}>{state?.paymentType}</p>
          </div>
          <div style={{ ...cardStyle, backgroundColor: "#ead1f1" }}>
            <p>
              <strong>Transaction Status</strong>
            </p>
            <p style={{ textTransform: "capitalize" }}>{state?.transactionStatus}</p>
          </div>
          <div style={{ ...cardStyle, backgroundColor: "#dcf2a7" }}>
            <p>
              <strong>Order Cost</strong>
            </p>
            <p style={{ textTransform: "capitalize" }}>₴{state?.totalPrice}</p>
          </div>
        </div>
        <div style={flexRow}>
          <div style={flexItem}>
            <h3>Delivery Address</h3>
            <div style={cardStyle}>
              {state?.deliveryType == "nova-poshta" && (
                <div>
                  <p style={{ textTransform: "capitalize" }}>
                    <strong>Delivery Method:</strong> {state?.deliveryType}
                  </p>
                  <p>
                    <strong>Name:</strong> {state?.userAddress?.name}
                  </p>
                  <p>
                    <strong>Address:</strong>{" "}
                    {state?.userAddress?.addressLine1 + " " + state?.userAddress?.addressLine2}
                  </p>
                  {state?.userAddress?.department && (
                    <p>
                      <strong>Department:</strong> {state?.userAddress?.department}
                    </p>
                  )}
                  <p>
                    <strong>City:</strong> {state?.userAddress?.city}
                  </p>
                  {/* <p>
                    <strong>Pincode:</strong> 385467
                  </p> */}
                  <p>
                    <strong>Phone:</strong> +{state?.userAddress?.number}
                  </p>
                </div>
              )}
              {state?.deliveryType == "pick-up" && (
                <div>
                  <p style={{ textTransform: "capitalize" }}>
                    <strong>Delivery Method:</strong> {state?.deliveryType}
                  </p>
                </div>
              )}
              {state?.deliveryType == "abroad" && (
                <div>
                  <p style={{ textTransform: "capitalize" }}>
                    <strong>Delivery Method:</strong> {state?.deliveryType}
                  </p>
                  <p>
                    <strong>Name:</strong>{" "}
                    {state?.orderDelivery?.firstName +
                      " " +
                      state?.orderDelivery?.middleName +
                      " " +
                      state?.orderDelivery?.lastName}
                  </p>
                  <p>
                    <strong>Address:</strong> {state?.orderDelivery?.address}
                  </p>
                  <p>
                    <strong>Phone:</strong>
                    {" +"}
                    {state?.orderDelivery?.mobileNumber}
                  </p>
                </div>
              )}
            </div>
          </div>
          <div style={flexItem}>
            <h3>Payment Details</h3>
            <div style={cardStyle}>
              {state?.paymentType == "invoice" && (
                <div>
                  {" "}
                  <p style={{ textTransform: "capitalize" }}>
                    <strong>Payment Method:</strong> {state?.paymentType}
                  </p>
                  <p>
                    <strong>Name:</strong>{" "}
                    {state?.orderPayment?.firstName +
                      " " +
                      state?.orderPayment?.middleName +
                      " " +
                      state?.orderPayment?.lastName}
                  </p>
                  <p>
                    <strong>Address:</strong> {state?.orderPayment?.address}
                  </p>
                  {/* <p>
                    <strong>Pincode:</strong> 385467
                  </p> */}
                  <p>
                    <strong>Phone:</strong> +{state?.orderPayment?.mobileNumber}
                  </p>
                </div>
              )}
              {state?.paymentType == "wayforpay" && (
                <div>
                  {" "}
                  <p style={{ textTransform: "capitalize" }}>
                    <strong>Payment Method:</strong> {state?.paymentType}
                  </p>
                </div>
              )}
              {state?.paymentType == "legal-cashless" && (
                <div>
                  {" "}
                  <p>
                    <strong>Payment Method:</strong> {state?.paymentType}
                  </p>
                  <p>
                    <strong>Name:</strong> {state?.orderPayment?.entityName}
                  </p>
                  <p>
                    <strong>EDRPOU_CODE:</strong> {state?.orderPayment?.EDRPOU_CODE}
                  </p>
                </div>
              )}
              {state?.paymentType == "individual-cashless" && (
                <div>
                  {" "}
                  <p style={{ textTransform: "capitalize" }}>
                    <strong>Payment Method:</strong> {state?.paymentType}
                  </p>
                  <p>
                    <strong>Name:</strong>{" "}
                    {state?.orderPayment?.firstName +
                      " " +
                      state?.orderPayment?.middleName +
                      " " +
                      state?.orderPayment?.lastName}
                  </p>
                  <p>
                    <strong>Address:</strong> {state?.orderPayment?.address}
                  </p>
                  <p>
                    <strong>Phone:</strong>
                    {" +"}
                    {state?.orderPayment?.mobileNumber}
                  </p>
                </div>
              )}
              {state?.paymentType == "cod" && (
                <div>
                  {" "}
                  <p>
                    <strong>Payment Method:</strong> Cash On Delivery
                  </p>
                </div>
              )}
            </div>
          </div>
          {/* <div style={flexItem}>
          <div style={cardStyle}>
            <h3>Status Order</h3>
            <p>
              <strong>Order ID:</strong> 78414
            </p>
            <p>
              <strong>Order Status:</strong> Pending
            </p>
            <p>
              <strong>Quantity:</strong> 2
            </p>
          </div>
        </div> */}
        </div>
        <div
          style={{
            marginTop: "15px",
            background: "#fff",
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #ddd",
          }}
        >
          <h3 style={{ fontSize: "16px", fontWeight: "bold" }}>Order Summary</h3>
          <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "15px" }}>
            <thead>
              <tr style={{ background: "#f5f5f5", textAlign: "left" }}>
                <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px" }}>
                  Name
                </th>
                <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px" }}>
                  Image
                </th>
                <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px" }}>
                  Quantity
                </th>
                <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px" }}>
                  Color
                </th>
                <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px" }}>
                  Warranty
                </th>
                <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px" }}>
                  Price
                </th>
                <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {state?.orderedProducts?.map((e, i) => (
                <tr key={i}>
                  <td
                    style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "12px" }}
                  >
                    {e.product?.nameEn}
                  </td>
                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "12px" }}>
                    <span
                      style={{
                        backgroundImage: `url(${e?.product?.image})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        width: "60px",
                        height: "60px",
                        display: "inline-block",
                      }}
                    ></span>
                  </td>
                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "12px" }}>
                    {e.quantity}
                  </td>
                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "12px" }}>
                    <span
                      style={{
                        display: "inline-block",
                        width: "20px",
                        height: "20px",
                        backgroundColor: `${e?.productColor?.colorCode}`,
                        borderRadius: "6px",
                      }}
                    ></span>
                  </td>
                  <td style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "12px" }}>
                    {e.productWarranty ? "Yes" : "No"}
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      borderBottom: "1px solid #ddd",
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                  >
                    ₴{e.price}
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      borderBottom: "1px solid #ddd",
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        // justifyContent: "center",
                        // alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <Tooltip
                        title='View'
                        style={{ cursor: "pointer" }}
                        onClick={() => redirect(e)}
                      >
                        <RemoveRedEyeRoundedIcon />
                      </Tooltip>
                    </span>
                  </td>
                </tr>
              ))}
              <tr style={{ textAlign: "center" }}>
                <td
                  colSpan={7}
                  style={{
                    padding: "8px",
                    fontWeight: "bold",
                    borderBottom: "1px solid #ddd",
                    fontSize: "16px",
                  }}
                >
                  Total: ₴{state?.totalPrice}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </DashboardLayout>
  );
};

export default OrderDetails;
